import { useEffect, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useGetProductDetails } from "../../../api/products";
import Loading from "../../../components/molecules/Loading";
import ProductForm from "../../../components/templates/ProductForm";
import useNotify from "../../../hooks/useNotify";
import { convertProductDetailsToRequest } from "../../../models/Product";
import { rootPaths } from "../../../routes/routePaths";
import { FORM_STATE, MODE, useFormStore } from "../../../stores/formStore";
import { productDefault } from "../create-product/CreateProduct.const";

const Product = () => {
  const location = useLocation();
  const stateMode = location.state?.mode ?? MODE.VIEW;

  const { productId } = useParams<{
    productId: string;
  }>();

  const resetForm = useFormStore(state => state.reset);
  const setStatus = useFormStore(state => state.setStatus);

  useEffect(() => {
    resetForm({ mode: stateMode, formState: FORM_STATE.SAVED });
  }, [resetForm, stateMode]);

  const { data: productDetails, isLoading } = useGetProductDetails({
    productId,
  });

  const { setNotifyError } = useNotify();
  const navigate = useNavigate();

  useEffect(() => {
    setStatus(productDetails?.status);
  }, [productDetails?.status]);

  const formDefaultValues = useMemo(() => {
    return productDetails
      ? convertProductDetailsToRequest(productDetails)
      : productDefault;
  }, [productDetails]);

  if (isLoading) {
    return <Loading />;
  }

  if (productDetails && productDetails.httpStatus === 404) {
    setNotifyError(
      productDetails.message
        ? productDetails.message
        : "Something went wrong. Please try again later!",
    );
    navigate(rootPaths.rewardInventoryPortal);
  }

  return (
    <ProductForm
      formDefaultValues={formDefaultValues}
      productDetails={productDetails}
    />
  );
};

export default Product;
